<template>

    <div class="label-report-line" :data-id="id" :data-layout-type="reportNode?.layout?.type"
        :style="{
            '--label-color': reportNode.layout.color
        }"
        :data-can-edit="canEdit ? 'true' : 'false'"
        :data-is-active="isActive ? 'true' : 'false'">

        <!-- Selected node header -->
        <div v-if="execMode == gConsts.rt.execModes.WORK" class="label-report-line__header">
            <labelNodeHeader @mouseenter.native="onHoverReportLine" @mouseleave.native="onLeaveReportLine" :showColorSquare="false" @click.native="toggleActive" :node="reportNode" />
            <button 
                v-if="canDelete"
                class="button--remove"
                @click="onRemoveLabelFromReport"
                title="Remover label do relatório"
            >
                <TrashCanIconSvg />
            </button>

            <button 
                v-if="canValidate"
                class="button--validate"
                @click="onToggleLabelValidation"
                :data-validated="isValidated ? 'true' : 'false'"
                title="Validar label"
            >
                <CheckIconSvg />
            </button>
        </div>

        <!-- Modo visualização -->
        <div v-if="!isEditingReportText" class="label-report-line__content">
            <squareColorUI v-if="reportNode.layout.color" :size="12"
                :color="reportNode.layout.color" class="label-report-line__square-color" />
            <span :data-can-edit="!isEditingReportText ? 'true' : 'false'" class="label-report-line__text" 
                @mouseenter="onHoverReportLine" @mouseleave="onLeaveReportLine" @click="toggleActiveReportText">
                <report-line-text :text="inputText" class="line" :isReadOnly="!canEdit"></report-line-text>
            </span>
        </div>  

        <!-- Modo de edição (WORK) -->
        <template v-if="isEditingReportText">
            <span class="label-report-line__text">
                <label-line-input :annotations="reportNode?.annotation.list || []" :value="inputText" 
                    @input="onUpdateInputText" @blur="onBlur" :autoFocus="true"
                    :labelReportNode="reportNode" 
                    :style="{ 
                        minWidth: minWidth + 'px'
                    }" :disabled="!canEdit" />
            </span>
        </template>
    </div>
</template>

<script>
import { gConsts } from '@/globals/gConsts';
import labelNodeHeader from '@/components/panels/relatorioDinamico/nodes/labelNode/labelNodeHeader.vue';
import { mapActions, mapGetters } from 'vuex';
import { evtBus } from '@/main';

import CheckIconSvg from '@/assets/icons/check.svg';
import TrashCanIconSvg from '@/assets/icons/trash-can.svg';
import squareColorUI from '@/components/ui/squareColor.vue';
import labelLineInput from '@/features/report/components/input/label/labelReportLineInput.vue';
import reportLineText from '@/features/report/components/text/reportLineText.vue';

import ReportNode from '@/features/report/models/ReportNode';

export default {
    name: 'labelReportLineCMP',
    components: {
        labelNodeHeader,
        TrashCanIconSvg,
        CheckIconSvg,
        squareColorUI,
        labelLineInput,
        reportLineText
    },
    props: {
        execMode: {
            type: String,
            default: gConsts.rt.execModes.WORK
        },
        reportNode: {
            type: ReportNode,
            required: true
        },
        id: {
            type: String,
            default: null
        },
        active: {
            type: Boolean,
            default: false
        },
        minWidth: {
            type: Number,
            default: 100
        },
        canEdit: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            isActive: this.active,
            gConsts: gConsts,
            inputText: this.reportNode?.reportText?.trim() || '',
            isHovering: false,
            isEditingReportText: false,
            isValidated: this.reportNode?.info?.validated ?? false,
        }   
    },

    watch: {
        active(newVal) {
            this.isActive = newVal;
        },
        reportNode: {
            handler(newVal) {
                this.inputText = newVal?.reportText?.trim() || '';
            },
            immediate: true,
            deep: true
        },
    },

    computed: {
        ...mapGetters([
        ]),

        canDelete() {
            return this.execMode == gConsts.rt.execModes.WORK && this.canEdit;
        },

        canValidate() {
            return this.execMode == gConsts.rt.execModes.WORK && this.canEdit && this.reportNode.info.insertionType == 'auto';
        },

    },

    methods: {
        ...mapActions([
            'ACT_reportNodes_updateLabelReportText',
            'ACT_reportNodes_addNewLabelReportText',
            'ACT_reportNodes_removeReportNode',
            'ACT_report_addCustomLineText',
            'ACT_reportNodes_updateLabelValidation',
        ]),

        onToggleLabelValidation() {
            if (!this.canValidate)
                return;
            
            this.isValidated = !this.isValidated;
            this.ACT_reportNodes_updateLabelValidation({ labelId: this.reportNode.id, validated: this.isValidated });
        },

        toggleActiveReportText() {
            if (!this.canEdit)
                return;
            // No modo visualizacao apenas ativa/desativa o label.
            // if (this.execMode == gConsts.rt.execModes.VIEW) {
            //     this.isActive = !this.isActive;
            //     evtBus.$emit('evt_relatorioDinamico_activateNode', { nodeId: this.reportNode.id, nodeType: gConsts.node.layout.types.LABEL });
            //     return;
            // }
            // No modo edicao pode ativar a edicao do texto
            if (!this.isActive) {
                evtBus.$emit('evt_relatorioDinamico_activateNode', { nodeId: this.reportNode.id, nodeType: gConsts.node.layout.types.LABEL });
            }
            this.isActive = true;
            this.isEditingReportText = true;
        },

        toggleActive() {
            if (!this.canEdit)
                return;
            this.isActive = !this.isActive;
            evtBus.$emit('evt_relatorioDinamico_activateNode', { nodeId: this.reportNode.id, nodeType: gConsts.node.layout.types.LABEL });
        },

        onUpdateInputText(value) {
            this.inputText = value;
            this.$emit('onUpdateInputText', this.inputText);
        },

        onBlur() {
            this.isEditingReportText = false;

            // Remove linha do relatorio caso apague todo texto
            if (this.inputText.length == 0) {
                this.onRemoveLabelFromReport();
            }
            
            // Atualiza o texto do label no report caso esteja ativo
            if (this.isActive) {
                // console.log('onBlur: updating label report text', this.inputText);
                this.ACT_reportNodes_updateLabelReportText({ labelId: this.reportNode.id, text: this.inputText });
            }
        },

        onRemoveLabelFromReport() {
            // Remove linha do report
            if (this.isActive) {
                evtBus.$emit('evt_relatorioDinamico_activateNode', { nodeId: this.reportNode.id, nodeType: gConsts.node.layout.types.LABEL });
            }
            this.ACT_reportNodes_removeReportNode({ nodeId: this.reportNode.id });
        },
        
        onHoverReportLine() {
            this.isHovering = true;
            // if (this.execMode != gConsts.rt.execModes.VIEW)
            //     return;
            evtBus.$emit('evt_tool_displayLabel', { label: this.reportNode.id });
        },

        onLeaveReportLine() {
            this.isHovering = false;
            // if (this.execMode != gConsts.rt.execModes.VIEW)
            //     return;
            evtBus.$emit('evt_tool_displayLabel', { label: null });
        }
    },

}
</script>

<style scoped>
@import '../../styles/shared/reportLine/label_report_line.css';

.label-report-line {
    position: relative;
}

.label-report-line[data-can-edit="true"] .label-report-line__header .label-node-header:hover {
    opacity: 0.8 !important;
    cursor: pointer;
}

.label-report-line[data-is-active="false"] .label-report-line__header .button--remove:not(:hover) {
    opacity: 0.5;
}

.label-report-line[data-is-active="false"] .label-report-line__header :deep(.label-node-header) {
    opacity: 0.6;
}

.label-report-line[data-can-edit="false"] {
    cursor: default;
}

.label-report-line[data-can-edit="true"] .label-report-line__text[data-can-edit="true"] .line:hover {
    cursor: text;
    opacity: 0.7;
    /* text-decoration: underline; */
}

/* Selected node header */
.label-report-line__header {
    display: flex;
    align-items: center;
    gap: var(--spacing-sm);
    animation: fadeIn 0.3s ease-in-out;
}

.label-report-line__header .label-node-header {
    width: auto;
    transition: opacity 0.2s ease;
}

.label-report-line__header > .button--remove {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    background: transparent;
    border: none;
    cursor: pointer;
    color: var(--color-dark-gray);
    transition: all 0.2s ease;
    flex-shrink: 0;
}

.label-report-line__header > .button--remove:hover:not(:disabled) {
    color: var(--color-error);
}

.label-report-line__header > .button--remove:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.label-report-line__header > .button--remove svg {
    width: 14px;
    height: 14px;
}


.label-report-line__header > .button--validate {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: auto;
    margin-right: var(--spacing-xs);
    padding: calc(var(--spacing-xs) / 2);
    --button-color: var(--color-warning);
    color: var(--button-color);
    background-color: color-mix(in srgb, currentColor 10%, transparent);
    border: 1px solid currentColor;
    border-radius: var(--radius-sm);
    box-shadow: 1px 1px 4px 0px #00000040;
    transition: all 0.2s ease;
    flex-shrink: 0;
    cursor: pointer;
}

.label-report-line__header > .button--validate svg {
    width: 10px;
    height: 10px;
    color: var(--color-black);
    background-color: var(--button-color);
    border-radius: 50%;
    padding: calc(var(--spacing-xs) / 2);
    transition: all 0.2s ease;
}

.label-report-line__header > .button--validate[data-validated="true"] {
    --button-color: var(--color-success);
}

.label-report-line__header > .button--validate:hover {
    opacity: 0.8;
    background-color: color-mix(in srgb, currentColor 30%, transparent);
}

/** Relatorio */

#relatorio[data-exec-mode="work"] .label-report-line {
    border-left: 3px solid var(--label-color, #ccc);
    padding-left: var(--spacing-sm);
    padding-block: var(--spacing-xs);
}

#relatorio[data-exec-mode="work"] .label-report-line[data-is-active="false"] {
    border-color: color-mix(in srgb, var(--label-color, #ccc), transparent 80%);
}

#relatorio[data-exec-mode="work"] .label-report-line[data-is-active="false"]:hover {
    border-color: color-mix(in srgb, var(--label-color, #ccc), transparent 50%);
    background-color: #efefef77;
}

#relatorio[data-exec-mode="work"] .label-report-line[data-is-active="true"] {
    /* border-right: 0.5px solid var(--label-color, #ccc);
    border-top: 0.5px solid var(--label-color, #ccc);
    border-bottom: 0.5px solid var(--label-color, #ccc); */
    /* background-color: color-mix(in srgb, var(--label-color, #ccc) 3%, transparent); */
    background-color: #efefefcc;
    border-width: 4px;
}

#relatorio[data-exec-mode="work"] .label-report-line__text {
    animation: fadeIn 0.3s ease-in-out;
}
    
#relatorio[data-exec-mode="view"][data-show-label-color-square="false"] .label-report-line:hover .square-color.label-report-line__square-color {
    display: block;
    position: absolute;
    /** Tamanho do quadrado + espaçamento */
    left: calc(-12px - var(--spacing-xs));
}

#relatorio[data-exec-mode="view"] .label-report-line[data-can-edit="true"] .label-report-line__text:hover {
    opacity: 0.8;
}

#relatorio[data-exec-mode="view"] .label-report-line[data-can-edit="true"] .label-report-line__text > .line{
    cursor: pointer;
}

</style>